import MOSTOFFEREDPERKS from 'data/mantechcar25/most-offered-perks.json';
import { useI18n } from 'hooks/useI18n';
import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const MostOfferedPerks: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');

  function keyToSlug(key: string): string {
    return key
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  }

  const keysFromData = [
    ...new Set(MOSTOFFEREDPERKS.flatMap((obj) => Object.keys(obj)))
  ].filter((key) => key !== 'year');

  const colors = [
    '#BDB9DA',
    '#8DD3C7',
    '#FB8274',
    '#7EAFD3',
    '#FDB563',
    '#B3DE68',
    '#666666',
    '#BC7FBD',
    '#CDEBC6',
    '#FFEE70',
    '#FFA07A',
    '#FF82A9',
    '#FFB7B2',
    '#FFD3B5',
    '#FF3E4E',
    '#FF6F61',
    '#FF9B85',
    '#FFC1A'
  ];

  function getPositionOfKey(data: any, key: string): number {
    return data[key] as number;
  }

  const CustomTickLabelLeft = Object.keys(MOSTOFFEREDPERKS[0])
    .filter((key) => key !== 'year')
    .sort(
      (a, b) =>
        getPositionOfKey(MOSTOFFEREDPERKS[0], a) -
        getPositionOfKey(MOSTOFFEREDPERKS[0], b)
    )
    .map((key) =>
      t(`mantechcar25.companies.most-offered-perks.${keyToSlug(key)}`)
    );

  const CustomTickLeft = ({ x, y, payload }: any): any => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={5}
          textAnchor="end"
          fontSize={16}
          fill="#353241"
          stroke="#353241"
          strokeOpacity="0.2"
        >
          {CustomTickLabelLeft[payload.value - 1]}
        </text>
      </g>
    );
  };

  const CustomTickLabelRight = Object.keys(
    MOSTOFFEREDPERKS[MOSTOFFEREDPERKS.length - 1]
  )
    .filter((key) => key !== 'year')
    .sort(
      (a, b) =>
        getPositionOfKey(MOSTOFFEREDPERKS[MOSTOFFEREDPERKS.length - 1], a) -
        getPositionOfKey(MOSTOFFEREDPERKS[MOSTOFFEREDPERKS.length - 1], b)
    )
    .map((key) =>
      t(`mantechcar25.companies.most-offered-perks.${keyToSlug(key)}`)
    );

  const CustomTickRight = ({ x, y, payload }: any): any => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={5}
          textAnchor="start"
          fontSize={16}
          fill="#353241"
          stroke="#353241"
          strokeOpacity="0.2"
        >
          {CustomTickLabelRight[payload.value - 1]}
        </text>
      </g>
    );
  };

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={500} width="99%" minWidth={850}>
          <LineChart
            width={500}
            height={300}
            data={MOSTOFFEREDPERKS}
            margin={{
              top: 20,
              right: 250,
              left: 250,
              bottom: 5
            }}
          >
            <XAxis
              dataKey="year"
              padding={{ left: 20, right: 20 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              yAxisId="left"
              domain={[1, keysFromData.length]}
              interval={0}
              tickCount={keysFromData.length}
              reversed
              tick={<CustomTickLeft />}
              axisLine={false}
              tickLine={false}
              padding={{ bottom: 20 }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              domain={[1, keysFromData.length]}
              interval={0}
              tickCount={keysFromData.length}
              reversed
              tick={<CustomTickRight />}
              axisLine={false}
              tickLine={false}
              padding={{ bottom: 20 }}
            />
            {keysFromData.map((key, index) => {
              return (
                <Line
                  key={key}
                  type="linear"
                  yAxisId="left"
                  dataKey={key}
                  stroke={colors[index]}
                  strokeWidth={4}
                  dot={{ stroke: '#A29EAE', strokeWidth: 1, r: 4 }}
                />
              );
            })}
            <Line type="linear" yAxisId="right" hide={true}></Line>
          </LineChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MostOfferedPerks;
